import { render, staticRenderFns } from "./Anniversary.vue?vue&type=template&id=2d9054b8"
import script from "./Anniversary.vue?vue&type=script&lang=js"
export * from "./Anniversary.vue?vue&type=script&lang=js"
import style0 from "./Anniversary.vue?vue&type=style&index=0&id=2d9054b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports